<template>
  <div id="modemList">
    <div class="common_tit_wrap">
      <div class="common_page_tit">모뎀 현황</div>
    </div>
    <div class="common_search_wrap">
      <div>
        <div class="common_search_item">
          <label>사업</label>
          <div>
            <select v-model="searchParams.prtSelect">
              <option value="">미선택</option>
              <option v-for="item in prtList" :key="'prt_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
            </select>
          </div>
        </div>
        <div class="common_search_item">
          <label>구축</label>
          <div>
            <select v-model="searchParams.sttSelect">
              <option value="">미선택</option>
              <option v-for="item in sttList" :key="'stt_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
            </select>
          </div>
        </div>
        <div class="common_search_item">
          <label>본부</label>
          <div>
            <select v-model="searchParams.ofc1Select">
              <option value="">미선택</option>
              <option v-for="item in ofc1List" :key="'ofc_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
            </select>
          </div>
        </div>
        <div class="common_search_item">
          <label>현재상태</label>
          <div>
            <select v-model="searchParams.crsSelect">
              <option value="">미선택</option>
              <option v-for="item in crsList" :key="'crs_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
            </select>
          </div>
        </div>
        <div class="common_search_item quarter3_width">
          <label>일자</label>
          <div>
            <select v-model="searchParams.searchDateTypeSelect">
              <option value="">없음</option>
              <option v-for="item in searchDateTypeList" :key="'date_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
            </select>
            <vue-datepicker-local
              v-model="searchParams.searchDateRange"
              inputClass="vdl_input"
              :local="ko"/>
          </div>
        </div>
        <div class="common_search_item quarter3_width">
          <label>키워드</label>
          <div>
            <select v-model="searchParams.searchKeywordSelect">
              <option value="">없음</option>
              <option v-for="item in searchKeywordTypeList" :key="'keyword_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
            </select>
            <input type="text" v-model="searchParams.searchKeyword"/>
            <div class="btn_search" @click="search(1)">검색</div>
          </div>
        </div>
      </div>
    </div>
    <div class="common_list_wrap">
      <div class="common_list_top">
        <div class="common_list_top_select">
          <select v-model="selectSize" @change="search(1)">
<!--            <option value="10">10줄 표시</option>-->
<!--            <option value="20">20줄 표시</option>-->
            <option value="50">50줄 표시</option>
            <option value="100">100줄 표시</option>
            <option value="200">200줄 표시</option>
            <option value="500">500줄 표시</option>
          </select>
        </div>
        <template v-if="mySession.userRole === 1 || mySession.userRole === 4 || mySession.userRole === 5">
          <div class="link fc_primary_blue" @click="downloadFile('/upload/templates/kepco_ams_modem_update_state_template.xlsx')">엑셀 상태 변경 템플릿 다운로드</div>
          <label for="excelUpdateFileBulk" class="btn_top btn_green">엑셀 일괄 상태 변경</label>
          <input
            type="file"
            id="excelUpdateFileBulk"
            @change="readUpdateExcelBulk"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            style="display: none;"
          />
          <template v-if="mySession.userRole === 4">
            <div class="link fc_primary_blue" @click="downloadFile('/upload/templates/kepco_ams_modem_template.xlsx')">엑셀 등록 템플릿 다운로드</div>
            <label for="excelFile" class="btn_top btn_green">엑셀 일괄 등록</label>
            <input
              type="file"
              id="excelFile"
              @change="readExcel"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              style="display: none;"
            />
            <div class="btn_top btn_green" @click="addModem">신규 모뎀 등록</div>
          </template>
        </template>
      </div>
      <div class="common_list_middle">
        <div class="common_list_head">
          <div><span><input type="checkbox" v-model="checkAll" @click.stop="onClickCheckAll"/></span></div>
          <div><span>본부</span></div>
          <div><span>사업구분</span></div>
          <div><span>구축구분</span></div>
          <div><span>이동전화번호</span></div>
          <div><span>등록일</span></div>
          <div><span>개통일</span></div>
          <div><span>처리현황</span></div>
          <div><span>현재상태</span></div>
          <div><span>기기이력</span></div>
        </div>
        <div class="common_list_body">
          <div class="common_list_no_data" v-if="list.length <= 0">
            <img src="../../assets/common/bg_list_no_data.png"/>
            <span>대상 모뎀이 없습니다.</span>
          </div>
          <div :key="'modem_' + item.modemPid" v-for="item in list">
            <div><span><input type="checkbox" v-model="item.check" :value="item.modemPid" @click.stop="onClickCheckItem(item)"/></span></div>
            <div>
              <span v-if="item.officeCode != null">
                <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === (item.officeCode.length === 5 ? item.officeCode : item.officeCode.substring(0, 5))">{{ofc1.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <span v-if="item.projectType != null">
                <template v-for="prt in prtList" v-if="prt.codeValue === item.projectType">{{prt.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <span v-if="item.structType != null">
                <template v-for="stt in sttList" v-if="stt.codeValue === item.structType">{{stt.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div><span class="link fc_primary_blue" @click="showPopup('모뎀정보 보기', 'ModemViewPopup', item)">{{item.mobileNum}}</span></div>
            <div><span>{{item.registerDate}}</span></div>
            <div><span>{{item.connectedDate}}</span></div>
            <div>
              <span v-if="item.progressType != null">
                <template v-for="prg in prgList" v-if="prg.codeValue === item.progressType">{{prg.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <template v-if="item.currentState != null">
                <template v-for="crs in crsList" v-if="crs.codeValue === item.currentState">
                  <span :key="'crs_' + crs.codePid" class="btn_status fc_white" :class="item.currentState === 'CRS01' ? 'bc_status_green' : 'bc_status_red'">{{crs.codeName}}</span>
                </template>
              </template>
              <span v-else>-</span>
            </div>
            <div><span class="link fc_primary_blue" @click="showPopup('모뎀이력 (' + item.mobileNum + ')', 'ModemHistoryPopup', item)">이력보기</span></div>
          </div>
        </div>
      </div>
      <div class="common_bottom_wrap">
        <template v-if="mySession.userRole === 1 || mySession.userRole === 5">
          <select v-model="crsSelect">
            <option value="">--일괄작업--</option>
            <option v-for="item in crsList" :key="'sel_crs_' + item.codePid" :value="item.codeValue" v-if="item.codeValue !== 0">{{item.codeName}}</option>
          </select>
          <div class="btn_apply" @click="changeModemState">적용</div>
        </template>
        <div class="btn_bottom btn_green_t" @click="downloadExcel">엑셀 다운로드</div>
        <div class="common_list_page_wrap">
          <paginate
            v-model="pageParams.page"
            :pageCount="pageParams.totalPage"
            :clickHandler="search"
            :prevText="'<'"
            :nextText="'>'"
            :containerClass="'page_wrap'">
          </paginate>
        </div>
      </div>
    </div>
    <excel-exporter ref="excel" :filter="filter" :type="'modem'" @downloading="excelDownloadStarted" @fail="excelDownloadFail"/>
    <modal name="viewPopup" classes="popup_modal" width="725px" height="auto" scrollable>
      <popup :popup-params="popupParams" @hidePopup="hidePopup" @editModem="editModem"/>
    </modal>
    <modal name="loadingProgress" classes="loading_progress_wrap" width="300px" height="200px">
      <div>{{progressMsg}}</div>
    </modal>
    <modal name="errorPopup" classes="popup_modal" width="725px" height="auto" scrollable>
      <div class="popup_wrap">
        <div class="popup_tit">
          <div>엑셀 일괄 등록 실패 목록</div>
        </div>
        <div class="popup_content">
          <div class="error_list_wrap">
            <div class="error_wrap" v-if="errorList999TotalCount > 0">
              <div class="error_wrap_tit">요청 실패 ({{ errorList999TotalCount }}건)</div>
              <div class="error_wrap_data" v-text="errorList999MobileNumText"></div>
            </div>
            <div class="error_wrap" v-if="errorList50TotalCount > 0">
              <div class="error_wrap_tit">이동전화번호 중복 ({{ errorList50TotalCount }}건)</div>
              <div class="error_wrap_data" v-text="errorList50MobileNumText"></div>
            </div>
            <div class="error_wrap" v-if="errorList100TotalCount > 0">
              <div class="error_wrap_tit">필수 정보 없음 ({{ errorList100TotalCount }}건)</div>
              <div class="error_wrap_data" v-text="errorList100MobileNumText"></div>
            </div>
            <div class="error_wrap" v-if="errorListOtherTotalCount > 0">
              <div class="error_wrap_tit">알 수 없는 오류 ({{ errorListOtherTotalCount }}건)</div>
              <div class="error_wrap_data" v-text="errorListOtherMobileNumText"></div>
            </div>
          </div>
        </div>
        <div class="popup_btn_wrap">
          <div class="btn_close" @click="hideErrorPopup">닫기</div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import VueDatepickerLocal from 'vue-datepicker-local'
import Popup from '../common/Popup.vue'
import ExcelExporter from '../excel/ExcelExporter.vue'
import modemInfo from '../../script/modemInfo'
import common from '../../script/common'
import {defaultLoadingOptions} from '../../script/defaultConfig'

export default {
  components: {VueDatepickerLocal, ExcelExporter, Popup},
  data () {
    return {
      // Common
      mySession: {},
      ko: common.getDatepickerLocal(),
      // Data
      afcList: [],
      ofcList: [],
      ofc1List: [],
      ofc2List: [],
      rwkList: [],
      prtList: [],
      sttList: [],
      prgList: [],
      crsList: [],
      // Search
      searchDateTypeList: [
        { codePid: 0, codeValue: 'supply', codeName: '납품일자' },
        { codePid: 1, codeValue: 'connected', codeName: '설치일자' }
      ],
      searchKeywordTypeList: [
        { codePid: 0, codeValue: 'mobile', codeName: '이동전화' },
        { codePid: 1, codeValue: 'usim', codeName: 'USIM' },
        { codePid: 2, codeValue: 'model', codeName: '모델명' }
      ],
      searchParams: {
        prtSelect: '', // 사업 선택
        sttSelect: '', // 구축 선택
        ofc1Select: '', // 본부 1차 선택
        crsSelect: '', // 모뎀 현재상태 선택
        searchDateTypeSelect: '', // 일자 분류 선택
        searchDateRange: [], // 일자 범위
        searchKeywordSelect: '', // 키워드 분류 선택
        searchKeyword: '' // 키워드
      },
      // List
      filter: {
        page: 1,
        size: parseInt(this.selectSize)
      },
      selectSize: '50',
      list: [],
      checkAll: false,
      selectedItemList: [],
      crsSelect: '',
      // Paging
      pageParams: {
        hasNext: false,
        totalElements: 0,
        totalPage: 1,
        page: 10,
        size: parseInt(this.selectSize)
      },
      // Popup
      popupParams: {
        title: '',
        component: '',
        data: {}
      },
      // Excel Download
      excelFilter: {
        page: 1,
        size: 100000 // 개수 제한
      },
      excelDownloading: false,
      // Excel Upload
      progressMsg: '',
      progress: 0,
      totalCount: 0,
      errorList: [],
      errorList999: [],
      errorList50: [],
      errorList100: [],
      errorListOther: [],
      // loading
      vueLoadingOverlay: null
    }
  },
  computed: {
    errorList999MobileNumText () {
      return this.getErrorMobileNumText(this.errorList999)
    },
    errorList50MobileNumText () {
      return this.getErrorMobileNumText(this.errorList50)
    },
    errorList100MobileNumText () {
      return this.getErrorMobileNumText(this.errorList100)
    },
    errorListOtherMobileNumText () {
      return this.getErrorMobileNumText(this.errorListOther)
    },
    errorList999TotalCount () {
      return this.getErrorMobileNumCount(this.errorList999)
    },
    errorList50TotalCount () {
      return this.getErrorMobileNumCount(this.errorList50)
    },
    errorList100TotalCount () {
      return this.getErrorMobileNumCount(this.errorList100)
    },
    errorListOtherTotalCount () {
      return this.getErrorMobileNumCount(this.errorListOther)
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('afcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('ofcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('rwkList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prtList')) &&
            common.checkValidateData('session', sessionStorage.getItem('sttList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prgList')) &&
            common.checkValidateData('session', sessionStorage.getItem('crsList'))) {
            clearInterval(interval)
            this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            this.ofc2List = this.getOfc2List()
            this.rwkList = JSON.parse(sessionStorage.getItem('rwkList'))
            this.prtList = JSON.parse(sessionStorage.getItem('prtList'))
            this.sttList = JSON.parse(sessionStorage.getItem('sttList'))
            this.prgList = JSON.parse(sessionStorage.getItem('prgList'))
            this.crsList = JSON.parse(sessionStorage.getItem('crsList'))
            if (this.$route.params != null && this.$route.params.searchParams != null) {
              this.searchParams = this.$route.params.searchParams
              this.search(1)
            } else {
              this.search(1)
            }
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  methods: {
    getErrorMobileNumText (errorList) {
      if (!Array.isArray(errorList) || errorList.length <= 0) {
        return ''
      }

      const mobileNumList = []

      for (let i = 0; i < errorList.length; i++) {
        const error = errorList[i]

        if (error == null) {
          continue
        }

        if (Array.isArray(error.list)) {
          for (let j = 0; j < error.list.length; j++) {
            if (error.list[j] != null && error.list[j] !== '') {
              mobileNumList.push(String(error.list[j]))
            }
          }
        } else if (error.mobileNum != null && error.mobileNum !== '') {
          mobileNumList.push(String(error.mobileNum))
        }
      }

      return mobileNumList.join(', ')
    },
    getErrorMobileNumCount (errorList) {
      if (!Array.isArray(errorList) || errorList.length <= 0) {
        return 0
      }

      let count = 0

      for (let i = 0; i < errorList.length; i++) {
        const error = errorList[i]

        if (error == null) {
          continue
        }

        if (Array.isArray(error.list)) {
          count += error.list.length
        } else if (error.mobileNum != null && error.mobileNum !== '') {
          count++
        }
      }

      return count
    },
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    getOfc2List () {
      return this.ofcList.filter(item => { return item.codeLevel === 1 })
    },
    onClickCheckAll () {
      this.selectedItemList = []
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].check = !this.checkAll
        if (!this.checkAll) {
          this.selectedItemList.push(this.list[i])
        }
      }
    },
    onClickCheckItem (selectedItem) {
      if (selectedItem.check) {
        this.selectedItemList = this.selectedItemList.filter(item => { return item.modemPid !== selectedItem.modemPid })
      } else {
        this.selectedItemList.push(selectedItem)
      }
      this.checkAll = this.selectedItemList.length === this.list.length
    },
    search (page) {
      this.filter = {
        page: page,
        size: parseInt(this.selectSize)
      }
      if (this.searchParams.prtSelect != null && this.searchParams.prtSelect !== '') {
        this.filter.projectType = this.searchParams.prtSelect
      } else {
        delete this.filter['projectType']
      }
      if (this.searchParams.sttSelect != null && this.searchParams.sttSelect !== '') {
        this.filter.structType = this.searchParams.sttSelect
      } else {
        delete this.filter['structType']
      }
      if (this.searchParams.ofc1Select != null && this.searchParams.ofc1Select !== '') {
        this.filter.officeCode = this.searchParams.ofc1Select
      } else {
        delete this.filter['officeCode']
      }
      if (this.searchParams.crsSelect != null && this.searchParams.crsSelect !== '') {
        this.filter.currentState = this.searchParams.crsSelect
      } else {
        delete this.filter['currentState']
      }
      delete this.filter['supplyDateMin']
      delete this.filter['supplyDateMax']
      delete this.filter['connectedDateMin']
      delete this.filter['connectedDateMax']
      if (this.searchParams.searchDateTypeSelect != null && this.searchParams.searchDateTypeSelect !== '' &&
        this.searchParams.searchDateRange != null && this.searchParams.searchDateRange.length === 2) {
        if (this.searchParams.searchDateTypeSelect === 'supply') {
          this.filter.supplyDateMin = common.getFormattedDate(this.searchParams.searchDateRange[0])
          this.filter.supplyDateMax = common.getFormattedDate(this.searchParams.searchDateRange[1])
        } else if (this.searchParams.searchDateTypeSelect === 'connected') {
          this.filter.connectedDateMin = common.getFormattedDate(this.searchParams.searchDateRange[0])
          this.filter.connectedDateMax = common.getFormattedDate(this.searchParams.searchDateRange[1])
        }
      }
      delete this.filter['mobileNum']
      delete this.filter['usim']
      delete this.filter['modelNum']
      if (this.searchParams.searchKeywordSelect != null && this.searchParams.searchKeywordSelect !== '' &&
        this.searchParams.searchKeyword != null && this.searchParams.searchKeyword.length > 0) {
        if (this.searchParams.searchKeywordSelect === 'mobile') {
          this.filter.mobileNum = this.searchParams.searchKeyword.replaceAll('-', '')
        } else if (this.searchParams.searchKeywordSelect === 'usim') {
          this.filter.usim = this.searchParams.searchKeyword
        } else if (this.searchParams.searchKeywordSelect === 'model') {
          this.filter.modelNum = this.searchParams.searchKeyword
        }
      }
      this.updateList()
    },
    updateList () {
      modemInfo.getModemInfo(this.filter, response => {
        console.log('getModemInfo', response)
        if (response.data.resultCode === 1) {
          const data = response.data.result.body
          let list = data.list
          for (let i = 0; i < list.length; i++) {
            list[i].check = false
          }
          this.list = list
          this.pageParams = {
            hasNext: data.hasNext,
            totalElements: data.totalElements,
            totalPage: data.totalPage,
            page: this.filter.page,
            size: this.filter.size
          }
        } else {
          common.amsAlert('retry', '모뎀현황 목록을 불러오지 못했습니다.')
          this.list = []
          this.pageParams = {
            hasNext: false,
            totalElements: 0,
            totalPage: 1,
            page: 1,
            size: this.filter.size
          }
        }
        this.checkAll = false
        this.selectedItemList = []
      })
    },
    showPopup (title, component, data) {
      this.popupParams.title = title
      this.popupParams.component = component
      this.popupParams.data = {type: 'M', data: data}
      this.$modal.show('viewPopup')
    },
    hidePopup () {
      this.$modal.hide('viewPopup')
    },
    addModem () {
      this.$router.push({
        name: 'ModemForm',
        params: {
          type: 'add',
          searchParams: this.searchParams
        }
      })
    },
    editModem (item) {
      this.$router.push({
        name: 'ModemForm',
        params: {
          type: 'edit',
          searchParams: this.searchParams,
          data: item
        }
      })
    },
    hideErrorPopup () {
      this.$modal.hide('errorPopup')
    },
    readExcel (e) {
      if ((this.mySession.subRole & 1) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      this.progressMsg = '데이터 읽는 중...'
      this.$modal.show('loadingProgress')
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      common.readExcel(e, 'MODEM')
        .then((result) => {
          console.log('모뎀 엑셀 일괄 등록', result.length)
          this.progressMsg = `데이터 검증 중 (0/${result.length})...`
          let resultCnt = 0
          for (let i = 0; i < result.length; i++) {
            result[i].mobileNum = result[i].mobileNum.replace(/\D/g, '')
            if (common.checkValidateData('string', result[i].affiliateCode)) {
              let affiliateCode = null
              for (let j = 0; j < this.afcList.length; j++) {
                if (result[i].affiliateCode === this.afcList[j].codeName) {
                  affiliateCode = this.afcList[j].codeValue
                }
              }
              result[i].affiliateCode = affiliateCode
            }
            if (common.checkValidateData('string', result[i].officeCode1)) {
              let officeCode = null
              for (let j = 0; j < this.ofc1List.length; j++) {
                if (result[i].officeCode1 === this.ofc1List[j].codeName) {
                  officeCode = this.ofc1List[j].codeValue
                }
              }
              if (common.checkValidateData('string', result[i].officeCode2)) {
                for (let j = 0; j < this.ofc2List.length; j++) {
                  if (result[i].officeCode2 === this.ofc2List[j].codeName) {
                    officeCode = this.ofc2List[j].codeValue
                  }
                }
              }
              result[i].officeCode = officeCode
            }
            if (common.checkValidateData('string', result[i].projectType)) {
              let projectType = null
              for (let j = 0; j < this.prtList.length; j++) {
                if (result[i].projectType === this.prtList[j].codeName) {
                  projectType = this.prtList[j].codeValue
                }
              }
              result[i].projectType = projectType
            }
            if (common.checkValidateData('string', result[i].structType)) {
              let structType = null
              for (let j = 0; j < this.sttList.length; j++) {
                if (result[i].structType === this.sttList[j].codeName) {
                  structType = this.sttList[j].codeValue
                }
              }
              result[i].structType = structType
            }
            if (!common.checkValidateData('string', result[i].supplyDate) ||
              !common.checkValidateLength('equal', result[i].supplyDate, 10) ||
              result[i].supplyDate.split('-').length !== 3) {
              delete result[i]['supplyDate']
            }
            if (!common.checkValidateData('string', result[i].connectedDate) ||
              !common.checkValidateLength('equal', result[i].connectedDate, 10) ||
              result[i].connectedDate.split('-').length !== 3) {
              delete result[i]['connectedDate']
            }
            if (!common.checkValidateData('string', result[i].registerDate) ||
              !common.checkValidateLength('equal', result[i].registerDate, 10) ||
              result[i].registerDate.split('-').length !== 3) {
              delete result[i]['registerDate']
            }
            resultCnt++
            this.progressMsg = `데이터 검증 중 (${resultCnt}/${result.length})...`
          }
          let intervalCnt = 0
          let interval = setInterval(() => {
            if (resultCnt === result.length) {
              clearInterval(interval)
              this.progressMsg = `데이터 작성 중 (0/${result.length})...`
              this.startProcessing(result, vueLoadingOverlay)
            } else if (intervalCnt > 10) {
              clearInterval(interval)
              vueLoadingOverlay.hide()
              common.amsAlert('retry', '엑셀 일괄 등록을 실패했습니다.')
            } else {
              intervalCnt++
            }
          }, 500)
        })
        .catch((error) => {
          this.$modal.hide('loadingProgress')
          vueLoadingOverlay.hide()
          console.error(error)
          common.amsAlert('general', error)
        })
    },
    async startProcessing (result, vueLoadingOverlay) {
      this.totalCount = result.length
      this.progress = 0
      this.errorList = []
      const chunkSize = 1000
      const totalChunks = result.length / chunkSize
      for (let i = 0; i < totalChunks; i++) {
        const start = i * chunkSize
        const end = start + chunkSize
        const chunk = result.slice(start, end)
        await this.processChunk(chunk, start, end)
        this.progress += 1000
        this.progressMsg = `데이터 작성 중 (${this.progress}/${result.length})...`
      }
      this.$modal.hide('loadingProgress')
      vueLoadingOverlay.hide()
      if (this.errorList != null && this.errorList.length > 0) {
        this.setErrorListByCode()
        common.amsAlert('general', '등록하지 못한 모뎀이 존재합니다.\n에러 팝업을 확인하세요.')
        this.$modal.show('errorPopup')
      } else {
        common.amsAlert('general', '엑셀 일괄 등록을 성공했습니다.')
      }
      this.updateList()
    },
    async processChunk (chunk, start, end) {
      return new Promise(resolve => {
        modemInfo.bulkInsertModemInfo({
          list: chunk
        }, response => {
          // console.log('bulkInsertModemInfo', response)
          if (
            response &&
            response.data &&
            response.data.resultCode === 1
          ) {
            if (
              response.data.result &&
              response.data.result.body &&
              response.data.result.body.errorList &&
              response.data.result.body.errorList.length > 0
            ) {
              this.appendErrorList(response.data.result.body.errorList)
            }
          } else {
            this.errorList.push(this.createChunkError(
              response && response.data ? response.data.resultCode : -999,
              start,
              end,
              chunk
            ))
          }
          resolve()
        }, error => {
          console.error(error)
          this.errorList.push(this.createChunkError(-999, start, end, chunk))
          resolve()
        })
      })
    },
    appendErrorList (items) {
      if (!Array.isArray(items) || items.length <= 0) {
        return
      }

      for (let i = 0; i < items.length; i++) {
        this.errorList.push(this.createSlimError(items[i]))
      }
    },
    createSlimError (error) {
      if (error == null) {
        return {
          errorCode: -999,
          mobileNum: ''
        }
      }

      return {
        errorCode: error.errorCode,
        mobileNum: error.mobileNum != null ? String(error.mobileNum) : '',
        registryNum: error.registryNum != null ? String(error.registryNum) : ''
      }
    },
    getMobileNumListFromChunk (chunk) {
      const list = []

      if (!Array.isArray(chunk)) {
        return list
      }

      for (let i = 0; i < chunk.length; i++) {
        const item = chunk[i]

        if (item == null) {
          continue
        }

        if (typeof item === 'string' || typeof item === 'number') {
          list.push(String(item))
        } else if (item.mobileNum != null) {
          list.push(String(item.mobileNum))
        }
      }

      return list
    },
    createChunkError (errorCode, start, end, chunk) {
      const mobileNumList = this.getMobileNumListFromChunk(chunk)

      return {
        errorCode: errorCode,
        start: start,
        end: end,
        count: mobileNumList.length,
        list: mobileNumList
      }
    },
    downloadFile (url) {
      if (url != null && url.length > 0) {
        common.fileDownload(url)
      }
    },
    downloadExcel () {
      if (this.excelDownloading) {
        common.amsAlert('general', '이미 다운로드 처리중입니다.')
        return
      }
      if (confirm('엑셀 다운로드는 데이터 양에 따라 상당한 시간이 소요될 수 있으며 데이터 10만개당 하나의 파일로 다운로드 됩니다.\n또한 브라우저 보안정책에 따라 연속 다운로드 권한을 허용해야합니다.\n정말 다운로드 하시겠습니까?')) {
        this.progressMsg = '다운로드 준비중...'
        this.$modal.show('loadingProgress')
        this.vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
        this.$refs.excel.runExport()
        this.excelDownloading = true
      }
    },
    excelDownloadStarted () {
      this.$modal.hide('loadingProgress')
      this.vueLoadingOverlay.hide()
      this.excelDownloading = false
    },
    excelDownloadFail () {
      this.$modal.hide('loadingProgress')
      this.vueLoadingOverlay.hide()
      this.excelDownloading = false
    },
    changeModemState () {
      if ((this.mySession.subRole & 1) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      if (this.selectedItemList.length === 0) {
        common.amsAlert('general', '먼저 모뎀을 선택해주세요.')
        return
      }
      let list = []
      for (let i = 0; i < this.selectedItemList.length; i++) {
        list.push(this.selectedItemList[i].modemPid)
      }
      modemInfo.currentStates({
        list: list,
        currentState: this.crsSelect
      }, response => {
        console.log('[모뎀 현황] 모뎀 상태 일괄 변경', response)
        if (response.data.resultCode === 1) {
          common.amsAlert('general', '일괄작업을 적용했습니다.')
          this.search(this.filter.page)
        } else {
          common.amsAlert('retry', '일괄작업을 적용하지 못했습니다.')
        }
      })
    },
    // 엑셀 일괄상태변경
    normalizeModemUpdateExcelData (list) {
      const normalizedList = []

      for (let i = 0; i < list.length; i++) {
        const item = Object.assign({}, list[i])

        // mobileNum 정리
        if (item.mobileNum != null) {
          item.mobileNum = item.mobileNum.toString().replace(/\D/g, '')
        }

        // 현재상태: 코드명으로 들어와도 codeValue로 변환
        if (common.checkValidateData('string', item.currentState) || item.currentState != null) {
          let currentState = item.currentState

          for (let j = 0; j < this.crsList.length; j++) {
            if (
              item.currentState === this.crsList[j].codeName ||
              item.currentState === String(this.crsList[j].codeValue) ||
              Number(item.currentState) === Number(this.crsList[j].codeValue)
            ) {
              currentState = this.crsList[j].codeValue
              break
            }
          }

          item.currentState = currentState
        }

        // 소속: 코드명 입력 시 codeValue로 변환
        if (common.checkValidateData('string', item.affiliateCode)) {
          for (let j = 0; j < this.afcList.length; j++) {
            if (item.affiliateCode === this.afcList[j].codeName) {
              item.affiliateCode = this.afcList[j].codeValue
              break
            }
          }
        }

        // 본부/지사: officeCode1, officeCode2가 있으면 officeCode로 변환
        if (common.checkValidateData('string', item.officeCode1)) {
          let officeCode = null

          for (let j = 0; j < this.ofc1List.length; j++) {
            if (
              item.officeCode1 === this.ofc1List[j].codeName ||
              item.officeCode1 === this.ofc1List[j].codeValue
            ) {
              officeCode = this.ofc1List[j].codeValue
              break
            }
          }

          if (common.checkValidateData('string', item.officeCode2)) {
            for (let j = 0; j < this.ofc2List.length; j++) {
              if (
                item.officeCode2 === this.ofc2List[j].codeName ||
                item.officeCode2 === this.ofc2List[j].codeValue
              ) {
                officeCode = this.ofc2List[j].codeValue
                break
              }
            }
          }

          if (officeCode != null) {
            item.officeCode = officeCode
          }

          delete item.officeCode1
          delete item.officeCode2
        }

        // 사업구분: 코드명 입력 시 codeValue로 변환
        if (common.checkValidateData('string', item.projectType)) {
          for (let j = 0; j < this.prtList.length; j++) {
            if (
              item.projectType === this.prtList[j].codeName ||
              item.projectType === this.prtList[j].codeValue
            ) {
              item.projectType = this.prtList[j].codeValue
              break
            }
          }
        }

        // 구축구분: 코드명 입력 시 codeValue로 변환
        if (common.checkValidateData('string', item.structType)) {
          for (let j = 0; j < this.sttList.length; j++) {
            if (
              item.structType === this.sttList[j].codeName ||
              item.structType === this.sttList[j].codeValue
            ) {
              item.structType = this.sttList[j].codeValue
              break
            }
          }
        }

        // 날짜 컬럼 정리
        this.normalizeExcelDateField(item, 'supplyDate')
        this.normalizeExcelDateField(item, 'connectedDate')
        this.normalizeExcelDateField(item, 'registerDate')

        normalizedList.push(item)
      }

      return normalizedList
    },
    normalizeExcelDateField (item, key) {
      if (
        !common.checkValidateData('string', item[key]) ||
        !common.checkValidateLength('equal', item[key], 10) ||
        item[key].split('-').length !== 3
      ) {
        delete item[key]
      }
    },
    setErrorListByCode () {
      this.errorList999 = []
      this.errorList50 = []
      this.errorList100 = []
      this.errorListOther = []

      for (let i = 0; i < this.errorList.length; i++) {
        const error = this.errorList[i]

        if (error.errorCode === -999) {
          this.errorList999.push(error)
        } else if (error.errorCode === -50) {
          this.errorList50.push(error)
        } else if (error.errorCode === -100) {
          this.errorList100.push(error)
        } else {
          this.errorListOther.push(error)
        }
      }
    },
    readUpdateExcelBulk (e) {
      if ((this.mySession.subRole & 1) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        e.target.value = ''
        return
      }

      this.progressMsg = '상태 변경 엑셀 데이터 읽는 중...'
      this.$modal.show('loadingProgress')
      const vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)

      common.readExcel(e, 'MODEM_UPDATE')
        .then(result => {
          const excelData = this.normalizeModemUpdateExcelData(result)

          if (excelData.length <= 0) {
            throw new Error('처리할 데이터가 없습니다.')
          }

          if (!confirm(excelData.length + '건의 모뎀 정보를 수정하시겠습니까?')) {
            this.$modal.hide('loadingProgress')
            vueLoadingOverlay.hide()
            return
          }

          this.startUpdateProcessingBulk(excelData, vueLoadingOverlay)
        })
        .catch(error => {
          this.$modal.hide('loadingProgress')
          vueLoadingOverlay.hide()
          console.error(error)
          common.amsAlert('general', error.message || error)
        })
        .finally(() => {
          e.target.value = ''
        })
    },
    async startUpdateProcessingBulk (list, vueLoadingOverlay) {
      this.totalCount = list.length
      this.progress = 0
      this.errorList = []

      const chunkSize = 1000
      const totalChunks = Math.ceil(list.length / chunkSize)

      for (let i = 0; i < totalChunks; i++) {
        const start = i * chunkSize
        const end = Math.min(start + chunkSize, list.length)
        const chunk = list.slice(start, end)

        this.progressMsg = `모뎀 정보 수정 중 (${end}/${list.length})...`

        await this.processUpdateChunkBulk(chunk, start, end)

        this.progress = end
      }

      this.$modal.hide('loadingProgress')
      vueLoadingOverlay.hide()

      if (this.errorList.length > 0) {
        this.setErrorListByCode()
        common.amsAlert('general', '수정하지 못한 모뎀이 존재합니다.\n에러 목록을 확인하세요.')
        this.$modal.show('errorPopup')
      } else {
        common.amsAlert('general', '엑셀 일괄 상태 변경을 완료했습니다.')
      }

      this.updateList()
    },
    processUpdateChunkBulk (chunk, start, end) {
      const updateList = chunk.map(item => {
        const data = Object.assign({}, item)

        // mobileNum 기준 수정이므로 modemPid는 보내지 않아도 됨
        delete data.modemPid
        delete data.check

        return data
      })

      return new Promise(resolve => {
        modemInfo.bulkUpdateModemInfo({
          list: updateList
        }, response => {
          console.log('bulkUpdateModemInfo', response)
          if (
            response &&
            response.data &&
            response.data.resultCode === 1
          ) {
            if (
              response.data.result &&
              response.data.result.body &&
              response.data.result.body.errorList != null &&
              response.data.result.body.errorList.length > 0
            ) {
              this.appendErrorList(response.data.result.body.errorList)
            }
          } else {
            this.errorList.push(this.createChunkError(
              response && response.data ? response.data.resultCode : -999,
              start,
              end,
              updateList
            ))
          }
          resolve()
        }, error => {
          console.error(error)
          this.errorList.push(this.createChunkError(-999, start, end, updateList))
          resolve()
        })
      })
    }
  }
}
</script>

<style scoped>
#modemList {
  display: flex;
  flex-direction: column;
  margin: 36px auto 46px;
}

#modemList .btn_search {
  flex-shrink: 0;
  width: 180px;
  height: 56px;
  border-radius: 4px;
  border: 1px solid #E2E8ED;
  background: #3E7EFF;
  color: #FFF;
  font-size: 14px;
  font-weight: 700;
  line-height: 56px;
  cursor: pointer;
}

#modemList .common_list_middle > .common_list_head > div,
#modemList .common_list_middle > .common_list_body > div > div {
  flex-shrink: 1;
  width: 100%;
}

#modemList .common_list_middle > .common_list_head > div:nth-child(1),
#modemList .common_list_middle > .common_list_body > div > div:nth-child(1) {
  flex-shrink: 0;
  width: 13px;
}

#modemList .common_list_middle > .common_list_head > div:nth-child(5),
#modemList .common_list_middle > .common_list_body > div > div:nth-child(5) {
  flex-shrink: 0;
  width: 85px;
}

#modemList .common_list_middle > .common_list_head > div:nth-child(6),
#modemList .common_list_middle > .common_list_body > div > div:nth-child(6),
#modemList .common_list_middle > .common_list_head > div:nth-child(7),
#modemList .common_list_middle > .common_list_body > div > div:nth-child(7) {
  flex-shrink: 0;
  width: 65px;
}

#modemList .common_bottom_wrap > select {
  margin: auto 0;
}

#modemList .common_bottom_wrap > .btn_apply {
  margin: auto 0 auto 7px;
}

#modemList .common_bottom_wrap > .btn_green_t {
  margin: auto 0 auto auto;
}

#modemList .common_bottom_wrap > .common_list_page_wrap {
  margin: auto 0;
}
</style>



// WEBPACK FOOTER //
// src/components/modemInfo/ModemList.vue